import React, { useState } from "react";
import cn from "classnames";
import styles from "./Preview.module.sass";
import Card from "../../../components/Card";
import { useData } from "../../../context/Barcode/BarcodeContext";

import Barcode from "react-barcode";
const Preview = ({ visible }) => {
  const { aboveLabel, belowLabel } = useData();

  return (
    <>
      <div className={cn(styles.preview, { [styles.visible]: visible })}>
        <Card
          className={styles.card}
          classCardHead={styles.head}
          title="Label Layout Preview"
          classTitle="title-blue"
        >
          <div
           className={styles.label_preview}
          >
            {/* Text above the barcode */}
            <p
              style={{
                marginBottom: "5px",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {aboveLabel}
            </p>

            {/* Barcode */}
            <Barcode
              value={"429837479823"}
              width={2.6}
              height={60}
              displayValue={false}
            />

            {/* Text below the barcode */}
            <p
              style={{ marginTop: "5px", fontSize: "14px", fontWeight: "bold" }}
            >
              {belowLabel}
            </p>
          </div>
        </Card>
      </div>
    </>
  );
};

export default Preview;
